import {
  IonButton,
  IonIcon,
  IonItem,
  IonLabel,
  IonReorder,
  IonReorderGroup,
} from "@ionic/react";
import React from "react";
import { removeCircleOutline as removeIcon } from "ionicons/icons";
import clsx from "clsx";

import {
  CreateGearboxTemplateParams,
  ITeacher,
  GearboxTemplate,
  UpdateGearboxTemplateParams,
} from "../../../../state";
import { TemplateState } from "../../../../pages/teacher/ManageBoxesPage/types";
import ModalConfirm from "../../../../molecules/ModalConfirm";
import { Menu } from "../../../../pages/teacher/ManageBoxesPage/types";

import styles from "./ManageTemplatesMenu.module.scss";

type Props = {
  calling: boolean;
  teacher: ITeacher;
  templates: GearboxTemplate[];
  editable: boolean;
  state: TemplateState;
  setState: React.Dispatch<React.SetStateAction<TemplateState>>;
  changeMenu: (menu: Menu) => void;
  createTemplate: (args: CreateGearboxTemplateParams) => void;
  updateTemplate: (args: UpdateGearboxTemplateParams) => void;
  deleteTemplate: (id: number) => void;
  update: (args: { [key: string]: any }) => void;
};

export default function ManageTemplatesMenu({
  calling,
  editable,
  templates,
  state,
  setState,
  deleteTemplate,
  update,
}: Props) {
  const doReorder = (event: CustomEvent) => {
    const sorted = event.detail.complete(templates);
    update({ templates: sorted });
  };

  const handleClickRemoveButton = (template: GearboxTemplate) => {
    if (!editable) {
      return;
    }
    setState(prev => ({
      ...prev,
      templateId: template.id,
      templateTitle: template.title,
      showDeleteTemplateConfirm: true,
    }));
  };

  return (
    <div className={styles.wrapper}>
      <ModalConfirm
        loading={calling}
        isOpen={state.showDeleteTemplateConfirm}
        message={
          <>
            「{state.templateTitle}」を削除しますか？
            <br />
            このテンプレートと紐づくBOXがある場合、
            <br />
            削除以降テンプレートは反映されなくなります。
            <br />
            この操作は取り消しができません。
          </>
        }
        buttons={[
          {
            title: "キャンセル",
            type: "None",
            action: () =>
              setState(s => ({ ...s, showDeleteTemplateConfirm: false })),
          },
          {
            title: "削除する",
            type: "Danger",
            action: () => {
              // showDeleteBoxConfirm = true とともに templateId をセットしているので null でないはず
              deleteTemplate(state.templateId!);
              setState(s => ({ ...s, showDeleteTemplateConfirm: false }));
            },
          },
        ]}
      />
      <IonReorderGroup
        disabled={!editable || calling}
        onIonItemReorder={doReorder}
      >
        {templates &&
          templates.map((template, i) => {
            return (
              <IonItem
                key={template.id}
                className={styles.templateItem}
                lines={i + 1 === templates.length ? "none" : "inset"}
              >
                {editable && (
                  <IonButton
                    className={styles.removeButton}
                    disabled={calling}
                    slot="start"
                    fill="clear"
                    size="large"
                    onClick={() => handleClickRemoveButton(template)}
                  >
                    <IonIcon icon={removeIcon} />
                  </IonButton>
                )}
                <IonLabel
                  id={`template-title-${template.id}`}
                  className={clsx(
                    styles.templateItemLabel,
                    editable && styles.pointer,
                  )}
                  onClick={() => {
                    if (editable) {
                      setState(s => ({
                        ...s,
                        templateId: template.id,
                        templateTitle: template.title,
                        templateDescription: template.description,
                        templateContent: template.content,
                        showTemplateForm: true,
                      }));
                    }
                  }}
                >
                  <div>{template.title}</div>
                </IonLabel>
                <IonReorder slot="end" className={styles.reorderIcon} />
              </IonItem>
            );
          })}
      </IonReorderGroup>
    </div>
  );
}
